import Glide from '@glidejs/glide';

class SideBySideSlider {
    start(el) {
        const slider = new Glide(el.querySelector('.glide'), {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            gap: 0,
        });

        slider.mount();
    }
}

window.app.add('sideBySideSlider', new SideBySideSlider());